import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

const UnauthenticatedRoute = ({ component: C, props: cProps, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                const defaultLocation = { pathname: '/store/dashboard' };

                let nextLocation = defaultLocation;
                if (props.location.state && props.location.state.from) {
                    const prevLocation = props.location.state.from;
                    const isString = (subject) => { return typeof subject === 'string' || subject instanceof String; };
                    const isExternalUrl = isString(prevLocation) && (
                        prevLocation.startsWith('http://') || prevLocation.startsWith('https://')
                    );

                    if (isExternalUrl && cProps.isAuthenticated) {
                        window.location = prevLocation;
                        return null;
                    }
                    nextLocation = prevLocation;
                }

                return (cProps.isAuthenticated)
                    ? <Redirect to={nextLocation} />
                    : <C {...props} {...cProps} />;
            }}
        />
    );
};

UnauthenticatedRoute.defaultProps = {
    location: {},
};

UnauthenticatedRoute.propTypes = {
    component: PropTypes.func.isRequired,
    props: PropTypes.object.isRequired,
    location: PropTypes.object,
};

export default UnauthenticatedRoute;
